"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDecorateConfig = getDecorateConfig;
exports.previewAdd = previewAdd;
exports.previewDecorateConfigInfo = previewDecorateConfigInfo;
exports.saveDecorateConfig = saveDecorateConfig;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
/**
 * 保存装修配置表
 * @param {Object} data - 装修配置数据
 * @returns {Promise}
 */
function saveDecorateConfig(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateConfig',
    method: 'post',
    data: data
  });
}

/**
 * 获取装修配置
 * @param {String} pageCode - 页面编码
 * @param {String} optionCode - 模块编码
 * @returns {Promise}
 */
function getDecorateConfig(pageCode, optionCode) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateConfig/decorateConfig',
    method: 'get',
    params: {
      pageCode: pageCode,
      optionCode: optionCode
    }
  });
}

/**
 * 预览装修配置信息
 * @param {Object} data - 装修配置数据
 * @returns {Promise}
 */
function previewDecorateConfigInfo(data, xcxType) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateConfig/previewDecorateConfigInfo',
    method: 'post',
    params: {
      xcxType: xcxType
    },
    data: data
  });
}

/**
 * 预览数据保存
 * @param {Object} data - 预览数据
 * @returns {Promise}
 */
function previewAdd(data) {
  return (0, _requestAuth.default)({
    url: '/xyDecorateConfig/previewAdd',
    method: 'post',
    data: data
  });
}